/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import { sortTableRow } from '../utils/sortTableRow';

export default function MainQuestionIsGrade({
  dataToShow,
  headerHeight,
  mainAlternatives,
  columnLabelKey,
}) {

  /**
   * Renderiza as colunas da grade na ordem canônica da tabela
   */
  function renderGradeColumns() {
    return mainAlternatives.map((alternativa) => (
      <td key={alternativa.id} className="gradeTitle-col">{alternativa[columnLabelKey]}</td>
    ));
  }

  /**
   * Renderiza as linhas de dados da tabela, incluindo resultados numéricos e percentuais
   */
  function renderTableRows(pergunta) {
    return sortTableRow(pergunta.alternativas).map((alternativa) => (
      <tr key={alternativa.id}>
        <td className="row">{alternativa.enunciado}</td>
        <td className="respondentes resultadoNumerico">
          <span>{alternativa.resultado_numerico}</span>
        </td>
        <td className="respondentes resultadoPercentual">
          {`${alternativa.resultado_percentual}%`}
        </td>
        {renderCrossingResults(alternativa)}
      </tr>
    ));
  }

  /**
   * Renderiza os cruzamentos de alternativas com base nos dados da alternativa atual
   */
  function renderCrossingResults(alternativa) {
    return mainAlternatives.map((item) => {
      const cruzamento = alternativa.cruzamentos[item.id];
      return (
        <td
          key={item.id}
          className={`resultado-cruzamento ${cruzamento?.marcacao?.is_checked ? 'selecionado' : ''}`}
          title={`Equivale a ${cruzamento?.resultado_numerico || ''} resposta(s)`}
        >
          <span>{`${cruzamento?.resultado_percentual || 0}%`}</span>
        </td>
      );
    });
  }

  return (
    <>
      {dataToShow.perguntas_principais[0].perguntas_cruzadas.map((pergunta) => (
        <tbody key={pergunta.id}>
          {/* Linha com o título da pergunta simples */}
          <tr>
            <th colSpan={dataToShow.perguntas_principais[0].alternativas.length + 4} style={{ top: headerHeight }}>
              <span className="pergunta-cruzada-wrapper">{pergunta.enunciado}</span>
            </th>
          </tr>

          {/* Linha verde com as colunas da grade */}
          <tr>
            <td className="gradeTitle"></td>
            <td colSpan="2" className="gradeTitle-col"></td>
            {renderGradeColumns()}
          </tr>

          {renderTableRows(pergunta)}
        </tbody>
      ))}
    </>
  );
}